var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { class: _vm.mainCssClass, attrs: { id: _vm.id } }, [
    _c("div", { staticClass: "content", class: _vm.contentClass }, [
      _c(
        "h2",
        {
          staticClass: "section__title",
          on: { click: _vm.emitSectionClicked },
        },
        [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n      "),
          _vm.preview != true
            ? _c("img", {
                staticClass: "section__title--icon-check",
                attrs: { src: "/images/icons_svg/checkbox-icon.svg" },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.preview != true
        ? _c(
            "div",
            { staticClass: "booking-content-inner" },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }